import { lazy, Suspense } from 'react';

const UserManagement = lazy(() =>
  import('@repo/ui/features/user/user-management').then((mod) => ({ default: mod.UserManagement })),
);

export default function UtilisateurListPage() {
  return (
    <Suspense fallback={<div className="flex items-center justify-center h-96">Chargement...</div>}>
      <UserManagement />
    </Suspense>
  );
}
